export const TARGET_TO_REGION_TYPE = {
  DOMESTIC_MOTEL: 'MOTEL',
  DOMESTIC_HOTEL: 'HOTEL',
  DOMESTIC_PENSION: 'PENSION',
  DOMESTIC_GUESTHOUSE: 'GUESTHOUSE',
} as const;
export type TargetType = keyof typeof TARGET_TO_REGION_TYPE;

export const REGION_TYPE_TO_PLACELIST_TYPE = {
  MOTEL: 'motel',
  HOTEL: 'hotel',
  PENSION: 'pension',
  GUESTHOUSE: 'guest-house',
} as const;
export type RegionType = keyof typeof REGION_TYPE_TO_PLACELIST_TYPE;
